// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import HourglassTwoToneSvg from "@ant-design/icons-svg/es/asn/HourglassTwoTone";
import AntdIcon from '../components/AntdIcon';

var HourglassTwoTone = function HourglassTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: HourglassTwoToneSvg
  }));
};

HourglassTwoTone.displayName = 'HourglassTwoTone';
export default React.forwardRef(HourglassTwoTone);